import { connect } from 'react-redux';
import { onLogout } from '../../redux/state';
import Header from './Header';

export const mapDispatchToProps = {
  onLogout,
};

export default connect(null, mapDispatchToProps)(Header);
